import { DOCUMENT, inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from '@environments/environment';
import { ApplicationType } from '@shared/enums';

@Injectable({
  providedIn: 'root',
})
export class HeadService {
  #document = inject(DOCUMENT);
  readonly #rendererFactory = inject(RendererFactory2);
  readonly #renderer: Renderer2 = this.#rendererFactory.createRenderer(null, null);

  /**
   * Inserts a performance tracking script if the current language is French.
   * https://fourniergroupe.atlassian.net/browse/DIGMOB-2806
   *
   * @returns {void}
   */
  insertPerformanceTrackingScript(): void {
    if (environment.applicationType === ApplicationType.PROD) {
      const performanceTag = this.#document.querySelectorAll('script[data-script]');
      performanceTag.forEach((tag) => tag.setAttribute('src', 'web-performance.js'));
    }
  }

  injectScripts(scripts: Partial<HTMLScriptElement>[]) {
    for (const script of scripts) {
      this.injectScript(script);
    }
  }

  injectScript(script: Partial<HTMLScriptElement>) {
    const scriptElement = this.#renderer.createElement('script') as HTMLScriptElement;

    for (const scriptProperty in script) {
      scriptElement.setAttribute(scriptProperty, script[scriptProperty as keyof HTMLScriptElement] as string);
    }

    this.#document.head.appendChild(scriptElement);
  }
}
